(function (root, factory) {
  var api = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }

  root.WiperProOptionOrder = api;
})(typeof window !== 'undefined' ? window : this, function () {
  'use strict';

  function productOptionNames(product) {
    return (product.options || []).map(function (option) {
      return typeof option === 'string' ? option : option.name;
    });
  }

  function sortValues(values, configuredOrder) {
    var positions = new Map();
    (configuredOrder || []).forEach(function (value, index) {
      positions.set(value, index);
    });

    return values
      .map(function (value, index) {
        return {
          value: value,
          position: positions.has(value) ? positions.get(value) : configuredOrder.length + index,
          originalPosition: index
        };
      })
      .sort(function (left, right) {
        return left.position - right.position || left.originalPosition - right.originalPosition;
      })
      .map(function (item) {
        return item.value;
      });
  }

  function firstAvailableValue(product, optionName, configuredOrder, selectedValues) {
    var names = productOptionNames(product);
    var targetIndex = names.indexOf(optionName);

    if (targetIndex < 0) {
      return null;
    }

    return (configuredOrder || []).find(function (candidate) {
      return (product.variants || []).some(function (variant) {
        if (variant.available === false || variant.options[targetIndex] !== candidate) {
          return false;
        }

        return names.every(function (name, index) {
          if (name === optionName || !Object.prototype.hasOwnProperty.call(selectedValues, name)) {
            return true;
          }

          return variant.options[index] === selectedValues[name];
        });
      });
    }) || null;
  }

  function optionNameFromInput(input) {
    var match = /^options\[(.+)\]$/.exec(input.name || '');
    return match ? match[1] : null;
  }

  function reorderSelect(select, configuredOrder) {
    var options = Array.from(select.options || []);
    var currentValues = options.map(function (option) { return option.value; });
    var orderedValues = sortValues(currentValues, configuredOrder);

    if (orderedValues.every(function (value, index) { return value === currentValues[index]; })) {
      return false;
    }

    var selectedValue = select.value;
    var byValue = new Map(options.map(function (option) { return [option.value, option]; }));
    orderedValues.forEach(function (value) {
      select.appendChild(byValue.get(value));
    });
    select.value = selectedValue;
    return true;
  }

  function init(config) {
    if (!config || !config.product || !config.optionOrder || typeof document === 'undefined') {
      return null;
    }

    var pendingBodySelection = false;
    var scheduled = false;

    function selectedValues() {
      var selected = {};
      document.querySelectorAll('select[name^="options["], input[name^="options["]:checked').forEach(function (input) {
        var name = optionNameFromInput(input);
        if (name) {
          selected[name] = input.value;
        }
      });
      return selected;
    }

    function applyOrder() {
      scheduled = false;
      document.querySelectorAll('select[name^="options["]').forEach(function (select) {
        var name = optionNameFromInput(select);
        if (name && Array.isArray(config.optionOrder[name])) {
          reorderSelect(select, config.optionOrder[name]);
        }
      });

      if (!pendingBodySelection || !Array.isArray(config.optionOrder['Select year'])) {
        return;
      }

      var selected = selectedValues();
      var desiredYear = firstAvailableValue(
        config.product,
        'Select year',
        config.optionOrder['Select year'],
        { 'Body type': selected['Body type'] }
      );
      var yearSelect = document.querySelector('select[name="options[Select year]"]');

      if (!desiredYear || !yearSelect || !Array.from(yearSelect.options).some(function (option) { return option.value === desiredYear; })) {
        return;
      }

      pendingBodySelection = false;
      if (yearSelect.value !== desiredYear) {
        yearSelect.value = desiredYear;
        yearSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function scheduleApply() {
      if (scheduled) {
        return;
      }
      scheduled = true;
      Promise.resolve().then(applyOrder);
    }

    document.addEventListener('change', function (event) {
      if (optionNameFromInput(event.target) === 'Body type') {
        pendingBodySelection = true;
      }
      scheduleApply();
    }, true);

    var observer = new MutationObserver(scheduleApply);
    observer.observe(document.querySelector('product-info') || document.body, {
      childList: true,
      subtree: true
    });
    applyOrder();

    return {
      disconnect: function () {
        observer.disconnect();
      }
    };
  }

  return {
    firstAvailableValue: firstAvailableValue,
    init: init,
    sortValues: sortValues
  };
});
